/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_R4Inputs */



/**
* | output |
* | --- |
* | "R4 Opponent twice" |
*
* @param {Rounds_R4Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_r4 = /** @type {((inputs?: Rounds_R4Inputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_R4Inputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("R4 Adversaire deux fois")
	if (locale === "es") return /** @type {LocalizedString} */ ("R4 Oponente dos veces")
	if (locale === "pt") return /** @type {LocalizedString} */ ("R4 Oponente duas vezes")
	if (locale === "it") return /** @type {LocalizedString} */ ("R4 Avversario due volte")
	return /** @type {LocalizedString} */ ("R4 Opponent twice")
});